// extracted by mini-css-extract-plugin
module.exports = {"iconList":"iconList-module--iconList--17t6A","item":"iconList-module--item--1kJFV","icon":"iconList-module--icon--2rUEu"};